import assuranceVieIllustration from '@/assets/images/investir/assurance-vie.svg';
import bourseIllustration from '@/assets/images/investir/bourse.svg';
import defiscalisationIllustration from '@/assets/images/investir/defiscalisation.svg';
import livretIllustration from '@/assets/images/investir/livret.svg';
import perIllustration from '@/assets/images/investir/per.svg';
import scpiImmobilierIllustration from '@/assets/images/investir/scpi-immobilier.svg';
import { URLS } from '@/constants/urls';

export interface InvestmentCardData {
  id: string;
  icon: string;
  titleKey: string;
  textKey: string;
  redirectUrl: string;
  /** Valeur envoyée en event_detail_1 du clic « decouvrir » ({categorie_de_placement} du plan de marquage). */
  trackingLabel: string;
}

export const INVESTMENT_CARDS: InvestmentCardData[] = [
  {
    id: 'assuranceVie',
    icon: assuranceVieIllustration,
    titleKey: 'invest.cards.assuranceVie.title',
    textKey: 'invest.cards.assuranceVie.text',
    redirectUrl: URLS.ASSURANCE_VIE_URL,
    trackingLabel: 'assurance_vie',
  },
  {
    id: 'per',
    icon: perIllustration,
    titleKey: 'invest.cards.per.title',
    textKey: 'invest.cards.per.text',
    redirectUrl: URLS.PER_URL,
    trackingLabel: 'per',
  },
  {
    id: 'livret',
    icon: livretIllustration,
    titleKey: 'invest.cards.livret.title',
    textKey: 'invest.cards.livret.text',
    redirectUrl: URLS.LIVRET_EPARGNE_URL,
    trackingLabel: 'livret_epargne',
  },
  {
    id: 'defiscalisation',
    icon: defiscalisationIllustration,
    titleKey: 'invest.cards.defiscalisation.title',
    textKey: 'invest.cards.defiscalisation.text',
    redirectUrl: URLS.DEFISCALISATION_URL,
    trackingLabel: 'defiscalisation',
  },
  {
    id: 'scpiImmobilier',
    icon: scpiImmobilierIllustration,
    titleKey: 'invest.cards.scpiImmobilier.title',
    textKey: 'invest.cards.scpiImmobilier.text',
    redirectUrl: URLS.SCPI_IMMOBILIER_URL,
    trackingLabel: 'scpi_immobilier',
  },
  {
    id: 'bourse',
    icon: bourseIllustration,
    titleKey: 'invest.cards.bourse.title',
    textKey: 'invest.cards.bourse.text',
    redirectUrl: URLS.BOURSE_URL,
    trackingLabel: 'bourse',
  },
];
